module.exports = __webpack_public_path__ + "static/8-3da2923ad72e9a6b2fa1294fc263757d.gif";